import { InvestmentDataTypes } from '../api/schema'
import { ListInvestmentCard } from './list-investment-card'

export const WatchlistInvestmentCard = ({
  investment,
}: {
  investment: InvestmentDataTypes
}) => (
  <ListInvestmentCard
    investment={investment}
    badgeText="On Watchlist"
    menuUrl={investment?.watchlist_details?.url ?? ''}
    listName="watchlist"
  />
)
